import { Link } from 'react-router-dom';

const footerLinks = {
  products: {
    title: '产品服务',
    links: [
      { label: '世界杯专区', path: '/category/worldcup' },
      { label: '全部产品', path: '/category/products' },
      { label: '新手指南', path: '/article/newbie-guide' },
      { label: '安全保障', path: '/article/security' },
    ],
  },
  company: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '加入我们', path: '/article/join-us' },
      { label: '新闻动态', path: '/category/news' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/article/faq' },
      { label: '用户协议', path: '/article/terms' },
      { label: '隐私政策', path: '/article/privacy' },
      { label: '投诉建议', path: '/about#contact' },
    ],
  },
};

const contactInfo = {
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  phone: '400-888-6688',
  email: 'hello@dajiang03.cn',
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block">
              <span className="font-heading text-3xl md:text-4xl font-bold tracking-tight">
                NOPAY<span className="text-accent-500">钱包</span>
              </span>
            </Link>
            <p className="mt-6 text-foreground-300 text-sm leading-relaxed max-w-sm">
              NOPAY钱包坚持秉持"用户体验至上、技术引领"的核心理念，致力于构建全球领先的安全公平、稳健高效的数字化娱乐殿堂。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-white hover:border-white transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">{footerLinks.products.title}</h4>
            <ul className="space-y-3">
              {footerLinks.products.links.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">{footerLinks.company.title}</h4>
            <ul className="space-y-3">
              {footerLinks.company.links.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">{footerLinks.support.title}</h4>
            <ul className="space-y-3">
              {footerLinks.support.links.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-5">联系方式</h4>
            <div className="space-y-4">
              <div>
                <p className="text-xs text-foreground-500 mb-1">地址</p>
                <p className="text-sm text-foreground-300">{contactInfo.address}</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">电话</p>
                <p className="text-sm text-foreground-300">{contactInfo.phone}</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-1">邮箱</p>
                <p className="text-sm text-foreground-300">{contactInfo.email}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} NOPAY钱包 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-5">
            <Link to="/article/terms" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">用户协议</Link>
            <Link to="/article/privacy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</Link>
            <Link to="/article/faq" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">常见问题</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}